export class StateMachine {
  constructor(initial, stateList) {
    this.stateList = stateList;
    this.state = this.findState(initial);
  }

  findState(name) {
    const state = this.stateList.find((state) => state.name === name);
    if (!state) throw Error(`Unknow state '${name}'`);
    return state;
  }

  canTransition(to) {
    return this.state.transitions.includes(to);
  }

  current() {
    return this.state.name;
  }

  component() {
    return this.state.component;
  }

  set(to) {
    const nextState = this.findState(to);
    if (!this.canTransition(to)) {
      throw new Error(`Invalid transition: ${this.current()} → ${to}`);
    } else {
      console.log(`state transition: ${this.current()} → ${to}`);
    }
    this.state = nextState;
    return this;
  }

  clone() {
    return new StateMachine(this.current(), this.stateList);
  }
}
